import './ccf-call-mask-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCallMaskIconProps extends SvgIconProps  {}

/**
 * Component displays call mask  svg icon 
 * @param props -CcfCallMaskIconProps
 * @returns call mask svg icon
 * @example - <CcfCallMaskIcon/>
 */
export function CcfCallMaskIcon(props: CcfCallMaskIconProps) {
  return (
    <SvgIcon width="38" height="30" viewBox="0 0 38 30" fill="none" {...props}>
     <path d="M18 10.6531V18.9388M23.2258 7.10204V22.4898M7.54837 10.6531V18.9388M28.4516 11.2449V18.3469M12.7742 2.95918V26.6327" stroke="#3F5C69" strokeWidth="3" strokeLinecap="round"/>
     <line y1="-1" x2="45.8587" y2="-1" transform="matrix(-0.785019 0.619471 -0.604858 -0.796333 36 0)" stroke="#3F5C69" strokeWidth="2"/>
    </SvgIcon>
  );
}

export default CcfCallMaskIcon;
